import React from 'react'
import { connect } from 'react-redux'
import { useParams } from 'react-router-dom'

import { getWitness } from '../ducks/witnesses.js'

import WitnessesForm from './witnesses_form.jsx'

const WitnessesEdit = () => {
  const { id } = useParams()
  
  return (
    <ConnectedForm witnessId={id} />
  )
}

const ConnectedForm = connect(
  (state, props) => ({
    witness: getWitness(state.witnesses, props.witnessId)
  })
)(({ witness }) => (
  <WitnessesForm witness={ witness } />
))

export default WitnessesEdit